import React from "react";
import FancyTitle from "./_shared/FancyTitle";
import Spacing from "./_shared/Spacing";

function Title({ title, icon, underline, spacing }) {
  return (
    <Spacing value={spacing}>
      <FancyTitle title={title} icon={icon} underline={underline} />
    </Spacing>
  );
}

export default Title;
